import { Button } from "antd";
import dataJson from "@/../public/data.json";
import "./index.less";

const prefix = "new-world";

function NewWorld() {
  const { design } = dataJson;
  return (
    <div className={prefix}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-title`}>{design.new_word_title}</div>
        <div className={`${prefix}-describe`}>{design.new_word_describe}</div>
        <Button type="primary" shape="round" style={{ marginTop: 45 }}>
          {dataJson.view_doc}
        </Button>
        <img src={design.energy_wave} alt="" className={`${prefix}-energy_wave`} />
        <img src={design.circle_ball} alt="" className={`${prefix}-circle`} />
      </div>
    </div>
  );
}

export default NewWorld;
